import { useEffect, useState } from "react";
import { ChatObject } from "../../../services/api/instances/botApi/types";

export const useChatListManager = (
  initialListIds: string[] | undefined,
  botRef: string | undefined,
) => {
  const [selectedChatIds, setSelectedChatIds] = useState<string[]>([]);
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    setIsInitialized(false);
  }, [botRef]);

  useEffect(() => {
    if (!isInitialized) {
      if (initialListIds && initialListIds.length > 0) {
        setSelectedChatIds(initialListIds);
      } else {
        setSelectedChatIds([""]);
      }
      setIsInitialized(true);
    }
  }, [initialListIds, isInitialized, botRef]);

  const handleAddBlock = () => {
    setSelectedChatIds((prev) => [...prev, ""]);
  };

  const handleDeleteBlock = (index: number) => {
    setSelectedChatIds((prev) => prev.filter((_, i) => i !== index));
  };

  const handleUpdateBlock = (index: number, chatId: string | null) => {
    setSelectedChatIds((prev) => {
      const newList = [...prev];
      newList[index] = chatId || "";
      return newList;
    });
  };

  return {
    selectedChatIds,
    handleAddBlock,
    handleDeleteBlock,
    handleUpdateBlock,
  };
};
